/**
 * OpeningHeader — section header for the Opening Likelihood block.
 *
 * Eyebrow: "OPENING LIKELIHOOD" (all-caps, brand-accent)
 * Headline: "Class of {activeYear} graduating"
 * Sub: "Replace upperclassmen leaving in {activeYear}"
 * Right side: "TARGET YEAR" label + YearTabs segmented control
 *
 * Mobile: column layout (eyebrow/headline/sub on top, tabs below)
 * Desktop: row layout (text left, tabs aligned to baseline-end on the right)
 *
 * Matches detail-frames.jsx OpeningHeader.
 */
import React from 'react';
import { YearTabs } from './YearTabs';

interface Props {
  activeYear: number;
  availableYears: readonly number[];
  onYearChange: (year: number) => void;
}

export function OpeningHeader({ activeYear, availableYears, onYearChange }: Props) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2.5 md:gap-4">
      {/* Text block */}
      <div>
        <div className="text-[11px] font-bold tracking-[0.1em] text-gray-500 uppercase">
          Opening Likelihood
        </div>
        <div className="mt-0.5 text-[22px] md:text-[26px] font-bold tracking-tight text-gray-900 leading-tight tabular-nums">
          Class of {activeYear} graduating
        </div>
        <div className="mt-1 text-[12px] text-gray-600">
          Replace upperclassmen leaving in {activeYear}
        </div>
      </div>

      {/* Year selector */}
      <div>
        <div className="text-[10px] font-semibold tracking-[0.1em] text-gray-500 uppercase mb-1">
          Target year
        </div>
        <YearTabs years={availableYears} active={activeYear} onChange={onYearChange} />
      </div>
    </div>
  );
}
